import {useState,useEffect,useRef}from"react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ItemValueEdit from '../../item/itemValueEdit';
import ItemNoteEdit from '../../item/itemNoteEdit';
import ItemSettingEdit from '../../item/itemSettingEdit';
import Select from "react-select";
import {all_routes} from "../../../../../feature-module/router/all_routes";
import {Toaster} from 'react-hot-toast';
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Str,Status_Type} from "biz9-utility";
import {Image_Type,Image_Table,Image_Field} from "biz9-image";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image} from "biz9-portal-app";
import {Store_Field} from "biz9-store";
import {Field,Message,Title} from "../../../../../constant";
import {Data,Dashboard,Image,Style,Toast_Message,App} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";

const Dashboard_App_Blog_Post_Edit = () => {
    const query = UrlQuery();
    const alert_prop = useRef(null);
    const [val_id,setValId] = useState(query.get('id'));
    const [val_sub_page_title,setValSubPageTitle] =  useState("");
    const [faq,setFaq] = useState(Data_Logic.get(Portal_Table.FAQ,0));
    const [photo_primary,setPhotoPrimary] = useState([]);
    const [groups,setGroups] = useState([]);
    const [field_values,setFieldValues] = useState([]);
    const [custom_fields,setCustomFields] = useState([]);
    //item-edit-end
    const [val_title,setValTitle] = useState("");
    const [val_description,setValDescription] = useState("");
    const photo_max_count = 1;
    const [item,setItem] = useState(Data_Logic.get(Portal_Table.FAQ,val_id));
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            if(val_id){
            get_data();
            }
            },[val_id]);
    async function get_data() {
        let [response,data] = await Portal_Remote_Data.get(App.get_url(Portal_Url.DATA_GET),Portal_Table.FAQ,val_id);
        bind_page(data);
        bind_field(data);
        bind_field_value(data);
        Toast_Message.dismiss();
    };
    async function bind_field_value(item) {
        setFieldValues(Data.bind_field_values(item));
    };
    async function bind_page(item) {
        setValSubPageTitle(item.title);
    };
    async function bind_field(item) {
        setItem(item);
        setValTitle(item.title);
        setValDescription(item.description);
    };
    async function post_field(item,field,value,option){
        if(!value){
            value = '';
        }
        if(field == Portal_Field.TITLE && !Str.check_is_null(item[Portal_Field.TITLE])){
            item[Portal_Field.TITLE_URL] = Str.get_title_url(value);
        }
        option = option ? option : {required:false,success_message:''};
        if(value.trim() === '' && option.required) {
            Toast_Message.error(Str.get_title(field) + " " +Message.INPUT_REQUIRED);
        }else{
            Toast_Message.loading(Message.SAVING);
            item[field] = value;
            setItem(item);
            bind_page(item);
            let option_post = {clean:true};
            let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Portal_Table.FAQ,item,option_post);
            if(!option.success_message){
                Toast_Message.success(response.message);
            }else{
                Toast_Message.success(option.success_message);
            }
        }
    };
   const updateValTitle = (event) => {
        setValTitle(event.target.value);
    };
     const handle_submit = (event) =>{
        event.preventDefault();
    };
    const updateValDescription = (event) => {
        setValDescription(event.target.value);
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="row justify-content-center">
            <div className="col-lg-10">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="settings-info bg-white">
            <ul className="nav nav-tabs nav-tabs-bottom mb-4">
            <li className="nav-item">
            <Link to={all_routes.dashboard_app_faq} className="nav-link" >
            {Dashboard.get_dash_edit_item_back_link(Portal_Table.FAQ)}
            </Link>
            </li>
            </ul>
            <div className="settings-page-lists">
            <ul className="settings-head nav nav-tabs" role="tablist">
            <li className="nav-item" role="presentation">
            <Link to="#" className="nav-link active" data-bs-toggle="tab" data-bs-target="#tab_general"
            aria-selected="false" role="tab" tabIndex={-1}>
            {Title.LABEL_CMS_TAB_GENERAL}
            </Link>
                </li>
                <li className="nav-item" role="presentation">
                <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_value" aria-selected="false"
                role="tab" tabIndex={-1}>
                {Title.LABEL_CMS_TAB_VALUE}
            </Link>
                </li>
                <li className="nav-item" role="presentation">
                <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_setting" aria-selected="false" role="tab"
                tabIndex={-1}>
                {Title.LABEL_CMS_TAB_SETTING}
            </Link>
                </li>
                </ul>
                </div>
                <div className="tab-content">
                {/* General Tab  */}
            <div className="tab-pane fade show active" id="tab_general" role="tabpanel">
                <div className="settings-card">
                <div className="settings-card-head bg-light">
                <h4>General</h4>
                </div>
                <form onSubmit={handle_submit}>
                <div className="settings-card-body">
                <div className="row">
                <div className="col-md-12" >
                <div className="form-wrap mb-3">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Title{" "}
            <span className="text-primary">*</span>
                </label>
                <input value={val_title} type="text" className="form-control" onChange={updateValTitle} onBlur={() => post_field(item,Portal_Field.TITLE,val_title,{required:true})} />
                </div>
                </div>
                <div className="col-md-12">
                <div className="form-wrap mb-3">
                <label className="mb-1 fw-medium text-dark">
                {" "}
            Description{" "}
            </label>
                <input value={val_description} onChange={updateValDescription} onBlur={() => post_field(item,Field.DESCRIPTION,val_description,{})} type="text" className="form-control" />
                </div>
                </div>
                </div>
                </div>
                </form>
                </div>
                </div>
                {/* /General Tab  */}
            {/* Value Tab */}
            <div className="tab-pane fade" id="tab_value" role="tabpanel">
                <ItemValueEdit field_values={field_values} item={item} onFieldValuesUpdate={setFieldValues} onItemUpdate={setItem} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
                </div>
                {/* Value Tab */}
            {/* Setting Tab */}
            <div className="tab-pane fade" id="tab_setting" role="tabpanel">
                <ItemSettingEdit item={item} onItemUpdate={post_field} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
                </div>
                {/* Setting Tab */}
            </div>
            {/* /Page Content */}
            </div>
                </div>
                </div>
                </div>
                </div>
                {/* /Page Content */}
            </>
                );
};
export default Dashboard_App_Blog_Post_Edit;
